function SimpleBenefitDescription(props) {
    return (
        <div className="mr-12">
            <img className="mb-5" src={props.icon} alt="" />
            <h5 className="text-lg font-extrabold mb-3">{props.name}</h5>
            <p className="text-blue-grey">{props.children}</p>
        </div>
    );
}

export default SimpleBenefitDescription;